import { s as state, c as customElement } from "./-chunk-@lit.js";
import { h as html } from "./-chunk-lit-html.js";
import { L as LitElement } from "./-chunk-lit-element.js";
import { C as CartApi } from "./-cart-api.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
let LitMiniCart = class extends LitElement {
  constructor() {
    super();
    this.isLoading = false;
    this.isOpen = false;
    this.itemCount = 0;
    this.backdrop = null;
    this.bubble = null;
    this.scrollPosition = 0;
    this.closeButton = null;
    this.handleCartUpdated = () => {
      this.loadCart();
    };
    this.handleCartLoading = () => this.loading(true);
    this.handleCartLoaded = () => this.loading(false);
    this.handleMiniCartOpen = () => this.open();
    this.handleMiniCartClose = () => this.close();
    this.handleBubbleClick = () => this.open();
    this.handleBackdropClick = () => this.close();
    this.handleCloseButtonClick = (e) => {
      e.preventDefault();
      this.close();
    };
    this.cartApi = CartApi.getInstance();
  }
  connectedCallback() {
    var _a, _b, _c;
    super.connectedCallback();
    this.backdrop = document.querySelector(".mini-cart__backdrop");
    this.bubble = document.getElementById("cart-icon-bubble");
    this.closeButton = document.querySelector(".js-cart-close");
    document.addEventListener("cart:loading", this.handleCartLoading);
    document.addEventListener("cart:loaded", this.handleCartLoaded);
    document.addEventListener("mini-cart:open", this.handleMiniCartOpen);
    document.addEventListener("mini-cart:close", this.handleMiniCartClose);
    document.addEventListener("cart-updated", this.handleCartUpdated);
    (_a = this.bubble) == null ? void 0 : _a.addEventListener("click", this.handleBubbleClick);
    (_b = this.backdrop) == null ? void 0 : _b.addEventListener("click", this.handleBackdropClick);
    (_c = this.closeButton) == null ? void 0 : _c.addEventListener("click", this.handleCloseButtonClick);
    this.loadCart();
  }
  disconnectedCallback() {
    var _a, _b, _c;
    super.disconnectedCallback();
    document.removeEventListener("cart:loading", this.handleCartLoading);
    document.removeEventListener("cart:loaded", this.handleCartLoaded);
    document.removeEventListener("mini-cart:open", this.handleMiniCartOpen);
    document.removeEventListener("mini-cart:close", this.handleMiniCartClose);
    document.removeEventListener("cart-updated", this.handleCartUpdated);
    (_a = this.bubble) == null ? void 0 : _a.removeEventListener("click", this.handleBubbleClick);
    (_b = this.backdrop) == null ? void 0 : _b.removeEventListener("click", this.handleBackdropClick);
    (_c = this.closeButton) == null ? void 0 : _c.removeEventListener("click", this.handleCloseButtonClick);
  }
  open() {
    const miniCart = document.querySelector(".mini-cart");
    const backdrop = document.querySelector(".mini-cart__backdrop");
    if (!miniCart || !backdrop) {
      console.error("Mini cart elements not found");
      return;
    }
    if (backdrop instanceof HTMLElement) {
      this.toggleTargetClass(backdrop, "active", true);
    }
    requestAnimationFrame(() => {
      if (miniCart instanceof HTMLElement) {
        this.toggleTargetClass(miniCart, "active", true);
        this.toggleTargetClass(miniCart, "animate", true);
      }
    });
    this.isOpen = true;
    this.scrollPosition = window.pageYOffset;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = "100%";
    const header = document.querySelector("#shopify-section-header");
    if (header instanceof HTMLElement) {
      header.style.zIndex = "89";
    }
  }
  close() {
    const miniCart = document.querySelector(".mini-cart");
    const backdrop = document.querySelector(".mini-cart__backdrop");
    if (!miniCart || !backdrop) {
      console.error("Mini cart elements not found");
      return;
    }
    if (miniCart instanceof HTMLElement) {
      this.toggleTargetClass(miniCart, "animate", false);
      this.toggleTargetClass(miniCart, "active", false);
    }
    if (backdrop instanceof HTMLElement) {
      this.toggleTargetClass(backdrop, "active", false);
    }
    this.isOpen = false;
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("width");
    window.scrollTo(0, this.scrollPosition);
    const header = document.querySelector("#shopify-section-header");
    if (header instanceof HTMLElement) {
      header.style.zIndex = "var(--zhighest)";
    }
  }
  async loadCart() {
    this.isLoading = true;
    try {
      const cart = await this.cartApi.getCart();
      this.itemCount = cart.item_count;
      this.updateCartCount();
    } catch (error) {
      console.error("Error loading cart:", error);
    } finally {
      this.isLoading = false;
    }
  }
  loading(isLoading) {
    this.isLoading = isLoading;
    const overlay = document.querySelector("[data-cart-overlay]");
    if (overlay) {
      if (isLoading) {
        overlay.classList.add("loading");
      } else {
        overlay.classList.remove("loading");
      }
    }
  }
  updateCartCount() {
    const countElement = document.querySelector(".mini-cart__top-count");
    if (countElement) {
      countElement.textContent = `(${this.itemCount})`;
    }
  }
  toggleTargetClass(target, className, flag) {
    target && target.classList.toggle(className, flag);
  }
  render() {
    return html`<slot></slot>`;
  }
};
__decorateClass([
  state()
], LitMiniCart.prototype, "isLoading", 2);
__decorateClass([
  state()
], LitMiniCart.prototype, "isOpen", 2);
__decorateClass([
  state()
], LitMiniCart.prototype, "itemCount", 2);
LitMiniCart = __decorateClass([
  customElement("lit-mini-cart")
], LitMiniCart);
let RemoveBundleButton = class extends LitElement {
  constructor() {
    super();
    this.isLoading = false;
    this.miniCart = null;
    this.handleBundleRemove = async (event) => {
      event.preventDefault();
      const cartLineItem = this.closest("[data-update-target]");
      if (!cartLineItem) {
        console.error("Cart line item not found");
        return;
      }
      const bundleId = cartLineItem.getAttribute("data-bundle-id");
      if (!bundleId) {
        console.error("Bundle ID not found");
        return;
      }
      try {
        document.dispatchEvent(new CustomEvent("cart:loading"));
        const cart = await this.cartApi.getCart();
        const itemsToRemove = cart.items.filter((item) => {
          var _a;
          return ((_a = item == null ? void 0 : item.properties) == null ? void 0 : _a._bundle_id_internal) === bundleId;
        }).map((item) => item.key).reduce((a, v) => ({ ...a, [v]: 0 }), {});
        if (Object.keys(itemsToRemove).length > 0) {
          await this.cartApi.updateCart({
            updates: itemsToRemove
          });
        }
        document.dispatchEvent(new CustomEvent("cart:loaded"));
        document.dispatchEvent(new CustomEvent("cart-updated"));
      } catch (error) {
        console.error("Error removing bundle:", error);
      }
    };
    this.cartApi = CartApi.getInstance();
    this.miniCart = document.querySelector("lit-mini-cart");
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.handleBundleRemove);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this.handleBundleRemove);
  }
  render() {
    return html`<slot></slot>`;
  }
};
__decorateClass([
  state()
], RemoveBundleButton.prototype, "isLoading", 2);
RemoveBundleButton = __decorateClass([
  customElement("cart-bundle-remove-button")
], RemoveBundleButton);
let CartRemoveButton = class extends LitElement {
  constructor() {
    super();
    this.isLoading = false;
    this.miniCart = null;
    this.handleRemove = async (event) => {
      event.preventDefault();
      const cartLineItem = this.closest("[data-update-target]");
      if (!cartLineItem) {
        console.error("Cart line item not found");
        return;
      }
      const itemKey = cartLineItem.getAttribute("data-item-key");
      if (!itemKey) {
        console.error("Item key not found");
        return;
      }
      try {
        this.isLoading = true;
        document.dispatchEvent(new CustomEvent("cart:loading"));
        await this.cartApi.updateCart({
          updates: { [itemKey]: 0 }
        });
        document.dispatchEvent(new CustomEvent("cart:loaded"));
        document.dispatchEvent(new CustomEvent("cart-updated"));
      } catch (error) {
        console.error("Error removing item:", error);
      } finally {
        this.isLoading = false;
      }
    };
    this.cartApi = CartApi.getInstance();
    this.miniCart = document.querySelector("lit-mini-cart");
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.handleRemove);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this.handleRemove);
  }
  render() {
    return html`<slot></slot>`;
  }
};
__decorateClass([
  state()
], CartRemoveButton.prototype, "isLoading", 2);
CartRemoveButton = __decorateClass([
  customElement("cart-remove-button")
], CartRemoveButton);
let CartItems = class extends LitElement {
  constructor() {
    super();
    this.isLoading = false;
    this.currentItemCount = 0;
    this.form = null;
    this.cartOverlay = null;
    this.lineItemStatusElement = null;
    this.bubble = null;
    this.cartApi = CartApi.getInstance();
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("cart:loading", () => this.loading(true));
    document.addEventListener("cart:loaded", () => this.loading(false));
    this.form = this.querySelector("form");
    this.cartOverlay = document.querySelector("[data-cart-overlay]");
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status");
    this.bubble = document.getElementById("cart-icon-bubble");
    if (this.form) {
      this.form.addEventListener("submit", this.submitForm.bind(this));
    }
    this.addEventListener("change", this.debouncedOnChange);
    this.updateItemCount();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("change", this.debouncedOnChange);
    if (this.form) {
      this.form.removeEventListener("submit", this.submitForm.bind(this));
    }
  }
  updateItemCount() {
    const quantityInputs = this.querySelectorAll('[name="updates[]"]');
    this.currentItemCount = Array.from(quantityInputs).reduce(
      (total, input) => total + parseInt(input.value || "0"),
      0
    );
  }
  submitForm(event) {
    var _a;
    if (((_a = event.submitter) == null ? void 0 : _a.id) === "notification-submit") {
      event.preventDefault();
    }
  }
  onChange(event) {
    var _a;
    const target = event.target;
    const cartLineItem = target.closest("[data-update-target]");
    if (!cartLineItem) return;
    const itemKey = cartLineItem.getAttribute("data-item-key");
    const handle = cartLineItem.getAttribute("data-handle");
    const name = (_a = document.activeElement) == null ? void 0 : _a.getAttribute("name");
    if (!itemKey || !name) return;
    this.updateQuantity(itemKey, target.value, name, handle);
  }
  async updateQuantity(line, quantity, name, handle) {
    try {
      document.dispatchEvent(new CustomEvent("cart:loading"));
      await this.cartApi.updateCart({
        updates: { [line]: parseInt(quantity) },
        sections: ["mini-cart"]
      });
      document.dispatchEvent(new CustomEvent("cart-updated", {
        detail: { line, quantity, name }
      }));
      this.updateLiveRegions(line, parseInt(quantity));
    } catch (error) {
      console.error("Error updating quantity:", error);
      if (document.getElementById("cart-errors")) {
        document.getElementById("cart-errors").textContent = "Error updating quantity";
      }
    } finally {
      document.dispatchEvent(new CustomEvent("cart:loaded"));
    }
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const errorElement = document.getElementById(`Line-item-error-${line}`);
      if (errorElement) {
        const errorText = errorElement.querySelector(".cart-item__error-text");
        if (errorText) {
          errorText.innerHTML = `Error updating quantity to ${itemCount}`;
        }
      }
    }
    this.currentItemCount = itemCount;
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", "true");
    }
    const cartStatus = document.getElementById("cart-live-region-text");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", "false");
      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", "true");
      }, 1e3);
    }
  }
  loading(isLoading) {
    this.isLoading = isLoading;
    if (this.cartOverlay) {
      if (isLoading) {
        this.cartOverlay.classList.add("loading");
      } else {
        this.cartOverlay.classList.remove("loading");
      }
    }
  }
  render() {
    return html`<slot></slot>`;
  }
};
__decorateClass([
  state()
], CartItems.prototype, "isLoading", 2);
__decorateClass([
  state()
], CartItems.prototype, "currentItemCount", 2);
CartItems = __decorateClass([
  customElement("cart-items")
], CartItems);
let LitProductRecommendations = class extends LitElement {
  constructor() {
    super();
    this.isLoading = false;
    this.recommendations = [];
    this.url = null;
    this.url = this.getAttribute("data-url");
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.url) {
      this.loadRecommendations();
    }
  }
  async loadRecommendations() {
    try {
      this.isLoading = true;
      const response = await fetch(this.url);
      const text = await response.text();
      const html2 = document.createElement("div");
      html2.innerHTML = text;
      const recommendations = html2.querySelector("product-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.recommendations = Array.from(recommendations.children).map((child) => ({
          html: child.outerHTML
        }));
      }
    } catch (error) {
      console.error("Error loading recommendations:", error);
    } finally {
      this.isLoading = false;
    }
  }
  render() {
    return html`<slot></slot>`;
  }
};
__decorateClass([
  state()
], LitProductRecommendations.prototype, "isLoading", 2);
__decorateClass([
  state()
], LitProductRecommendations.prototype, "recommendations", 2);
LitProductRecommendations = __decorateClass([
  customElement("lit-product-recommendations")
], LitProductRecommendations);
export {
  CartItems,
  CartRemoveButton,
  LitMiniCart,
  LitProductRecommendations,
  RemoveBundleButton
};
